import { useQuery } from '@tanstack/react-query';
import { messagesKeys } from './messages.keys';
import { getMessageStatuses } from './messages.api';
export const useMessageStatusesQuery = (messageId, enabled) => {
    return useQuery({
        queryKey: messagesKeys.statuses(messageId),
        queryFn: () => getMessageStatuses(messageId),
        enabled
    });
};
//# sourceMappingURL=messages.query.js.map